import { configureStore } from '@reduxjs/toolkit'

import { globalNamespace } from '@/redux/global-actions'

import { activityLogSlice } from './activity-log'
import { apiKeySlice } from './api-key'
import { botSlice } from './bot'
import { botVersionSlice } from './bot-version'
import { botWorkflowSlice } from './bot-workflow'
import { competitionSlice } from './competition'
import { competitionBettingSlice } from './competition-betting'
import { fileSlice } from './file'
import global from './global'
import { licenseSlice } from './license'
import { llmSlice } from './llm'
import { notificationSlice } from './notification'
import { rankingSlice } from './ranking'
import { userSlice } from './user'
import { appListener } from './utils'
import { walletSlice } from './wallet'

export const store = configureStore({
  reducer: {
    [globalNamespace]: global,
    [userSlice.reducerPath]: userSlice.reducer,
    [walletSlice.reducerPath]: walletSlice.reducer,
    [fileSlice.reducerPath]: fileSlice.reducer,
    [apiKeySlice.reducerPath]: apiKeySlice.reducer,
    [competitionSlice.reducerPath]: competitionSlice.reducer,
    [competitionBettingSlice.reducerPath]: competitionBettingSlice.reducer,
    [activityLogSlice.reducerPath]: activityLogSlice.reducer,
    [rankingSlice.reducerPath]: rankingSlice.reducer,
    [llmSlice.reducerPath]: llmSlice.reducer,
    [licenseSlice.reducerPath]: licenseSlice.reducer,
    [botSlice.reducerPath]: botSlice.reducer,
    [botVersionSlice.reducerPath]: botVersionSlice.reducer,
    [botWorkflowSlice.reducerPath]: botWorkflowSlice.reducer,
    [notificationSlice.reducerPath]: notificationSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      appListener.middleware,
      userSlice.middleware,
      walletSlice.middleware,
      fileSlice.middleware,
      apiKeySlice.middleware,
      competitionSlice.middleware,
      competitionBettingSlice.middleware,
      activityLogSlice.middleware,
      rankingSlice.middleware,
      llmSlice.middleware,
      licenseSlice.middleware,
      botSlice.middleware,
      botVersionSlice.middleware,
      botWorkflowSlice.middleware,
      notificationSlice.middleware,
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
